import React, { useContext, useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { ShopContext } from "../context/ShopContext";
import { assets } from "../assets/assets";
import RelatedProducts from "../components/RelatedProducts";
import Toast from "./Tost";
import {
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaTelegramPlane,
  FaCopy,
  FaStar
} from "react-icons/fa";
import { CiStar } from "react-icons/ci";
import { RiTwitterXLine, RiStarSmileFill } from "react-icons/ri";
import { BsBox } from "react-icons/bs";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import OurPolicycart from "../components/OurPolicycart";
import RecentPurchases from "../components/RecentPurchases";
import SizeChartModal from "../components/SizeChartModal";
import axios from "axios";
// -[#FF4902]
const Product = () => {
  const [isModalOpen, setIsModalOpen] = useState(false); // State to toggle modal
  const { productId } = useParams();
  const { products, currency, addToCart, backendUrl, userData, token } =
    useContext(ShopContext);

  const [productData, setProductData] = useState(false);
  const [image, setImage] = useState("");
  const [size, setSize] = useState("");
  const [color, setColor] = useState("");
  const [review, setReview] = useState({
    userName: "",
    rating: 0,
    comment: ""
  });
  const [reviews, setReviews] = useState([]);
  const [activeTab, setActiveTab] = useState("description"); // 'description' or 'reviews'
  const [displayedReviews, setDisplayedReviews] = useState(10);
  const [toast, setToast] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [reviewSubmitted, setReviewSubmitted] = useState(false);
  const { slug } = useParams(); // now we take slug, not productId
  const navigate = useNavigate();
  // const [isOpen, setIsOpen] = useState(false);
  // const [zoom, setZoom] = useState(false);
  // const [position, setPosition] = useState({ x: 0, y: 0 });
  // const imgRef = useRef(null);
  // const [scale, setScale] = useState(1);
  // const [toast, setToast] = useState(null);

  useEffect(() => {
    const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
    // axios.post(`${backendUrl}/api/analytics/visit`, { page: "Profile" })
    axios
      .post(`${backendUrl}/api/analytics/visit`, { page: productData.name })
      .then((res) => console.log(" visit recorded:", res.data))
      .catch((err) => console.error("Analytics error:", err));
  }, [productData]);
  const handleStarClick = (star) => {
    setReview({ ...review, rating: star });
  };

  const [isOpen, setIsOpen] = useState(false);
  const [zoom, setZoom] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const imgRef = useRef(null);
  const [scale, setScale] = useState(1);

  const handleMouseMove = (e) => {
    if (!imgRef.current) return;

    const { left, top, width, height } = imgRef.current.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;

    setPosition({ x, y });
  };

  // const handleMouseMove = (e) => {
  //   if (!imgRef.current) return;

  //   const { left, top, width, height } = imgRef.current.getBoundingClientRect();
  //   const x = ((e.pageX - left) / width) * 100;
  //   const y = ((e.pageY - top) / height) * 100;

  //   setPosition({ x, y });
  // };

  // Fetch product data and reviews from the database
  // const fetchProductData = async () => {
  //   const product = products.find((item) => item._id === productId);
  //   if (product) {
  //     setProductData(product);
  //     setImage(product.image[0]);

  //     try {
  //       const response = await fetch(`${backendUrl}/api/product/${productId}/reviews`);
  //       if (response.ok) {
  //         const data = await response.json();
  //         console.log('Fetched reviews:', data);
  //         setReviews(data.reviews || []); // Fallback to an empty array
  //       } else {
  //         console.warn('Failed to fetch reviews:', response.status, response.statusText);
  //         setReviews([]);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching reviews:', error.message);
  //       setReviews([]);
  //     }
  //   } else {
  //     console.warn(`Product with ID ${productId} not found in the product list.`);
  //   }
  // };

  useEffect(() => {
    // const product = products.find((item) => item._id === productId);
    // Convert slug back to normal name

    const productName = slug.replace(/_/g, " ").toLowerCase();
    // Find product in the context list
    const product = products.find(
      (item) => item.name.toLowerCase() === productName
    );
    if (product) {
      setProductData(product);
      setImage(product.image[0]);
      setReviews(Array.isArray(product.reviews) ? product.reviews : []);
    } else {
      console.warn(`Product with ID ${productId} not found.`);
    }
  }, [productId, products]);

  const showMore = () => {
    const additionalReviews = reviews.slice(
      displayedReviews.length,
      displayedReviews.length + 15
    );
    setDisplayedReviews([...displayedReviews, ...additionalReviews]);
  };

  const productLink = `https://mammothstreetwears.com/product/${slug}`;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(productLink);
    toast.success("Copied to clipboard!", {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true
    });
  };

  const calculateAverageRating = () => {
    if (!Array.isArray(reviews) || reviews.length === 0) return 0;
    const totalRating = reviews.reduce(
      (sum, review) => sum + (review?.rating || 0),
      0
    );
    return (totalRating / reviews.length).toFixed(1);
  };

  // useEffect(() => {
  //   window.scrollTo(0, 0); // Scroll to top when the component is mounted
  // }, []);

  const getRatingCounts = () => {
    const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    reviews.forEach((review) => {
      if (review?.rating) {
        counts[review.rating]++;
      }
    });
    return counts;
  };

  const getProgressBarWidth = (ratingCount, totalReviews) => {
    return (ratingCount / totalReviews) * 100;
  };

  const submitReview = async () => {
    if (!review.userName || review.rating < 1 || review.rating > 5) {
      setToast({
        message: "Please provide a valid name and rating (1-5).",
        type: "error"
      });
      return;
    }

    const reviewPayload = {
      userName: review.userName,
      rating: review.rating,
      comment: review.comment || "No comment provided"
    };

    try {
      const response = await fetch(
        `${backendUrl}/api/product/${productData._id}/addReview`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(reviewPayload)
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error:", errorData.message);
        alert(errorData.message || "Failed to submit the review.");
        return;
      }

      const data = await response.json();
      if (data.success) {
        setReviews((prevReviews) => [...prevReviews, data.newReview]);
        setReview({ userName: "", rating: 0, comment: "" });
        // setToast({ message: 'Review submitted successfully!', type: 'success' });
        setActiveTab("reviews"); // Switch to the Reviews tab
        // setIsModalOpen(false); // Close the modal after submission
        window.location.reload();
      } else {
        setToast({
          message: data.message || "Failed to submit the review.",
          type: "error"
        });
      }
    } catch (error) {
      console.error("Error submitting review:", error.message);
      alert("Something went wrong. Please try again later.");
    }
  };
  const getProgressBarColor = (rating) => {
    switch (rating) {
      case "5":
        return "bg-black";
      case "4":
        return "bg-black";
      case "3":
        return "bg-black";
      case "2":
        return "bg-black";
      case "1":
        return "bg-black";
      default:
        return "bg-black";
    }
  };

  const colorMapping = {
    "#F6F6F6": "Bone White",
    "#151515": "Magma Black",

    "#C5DDAC": "Moss Green",
    "#242E44": "Midnight Blue",
    "#90867D": "Amber Crust",
    "#FAEEB2": "Ivory Ember",
    "#745539": "Amber Crust",
    "#2C2CBD": "Midnight Blue"
  };
  // "#D5C6DA": "Ancient Lavender",

  const showToast = (message, type = "error") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000); // Hide after 3 sec
  };

  const handleAddToCart = () => {
    if (!color) {
      showToast("Please select a color.", "error");
      return;
    }
    if (!size) {
      showToast("Please select a size.", "error");
      return;
    }

    if (!token) {
      // Store the selected product details in local storage before redirecting
      localStorage.setItem(
        "pendingCartItem",
        JSON.stringify({
          itemId: productData._id,
          size,
          color
        })
      );

      // Redirect user to login
      navigate("/login");
    } else {
      addToCart(productData._id, size, color);
      showToast("Item added to cart! ✅", "success");
    }
  };

  return productData ? (
    <>
      <Helmet>
        <title>{`${productData.name} - Online Streetwear Store`}</title>
        <meta name="description" content={productData.metadescription} />
        <meta name="keywords" content={`${productData.keywords}`} />
        <meta property="og:title" content={productData.metatitle} />
        <meta property="og:description" content={productData.description} />
        <meta property="og:image" content={productData.image[0]} />
        <meta property="og:url" content={productLink} />
        <meta name="twitter:title" content={productData.name} />
        <meta name="twitter:description" content={productData.description} />
        <meta name="twitter:image" content={productData.image[0]} />
      </Helmet>

      <div className="border-t-2 pt-10 transition-opacity ease-in duration-500 opacity-100 sm:mr-2 sm:ml-2 mr-4 ml-4">
        <div className="flex gap-12 sm:gap-12 flex-col sm:flex-row  ">
          {/* Product Images */}
          <div className="flex-1 flex flex-col-reverse gap-3 sm:flex-row ">
            <div className="flex sm:flex-col overflow-x-auto sm:overflow-y-scroll justify-between sm:justify-normal sm:w-[18.7%] w-full">
              {productData.image.map((item, index) => (
                <img
                  onClick={() => setImage(item)}
                  src={item}
                  key={index}
                  className="w-[24%] sm:w-full sm:mb-3 flex-shrink-0 cursor-pointer"
                  alt=""
                />
              ))}
            </div>
            {/* <div className='w-full sm:w-[80%]'>
            <img className='w-full h-auto' src={image} alt='' />
          </div> */}
            {/* Main image - click to open popup */}
            <div className="w-full sm:w-[80%]">
              {/* Normal Image */}
              <img
                src={image}
                alt="product"
                className="w-full h-auto cursor-pointer border"
                onClick={() => setIsOpen(true)}
              />

              {/* Popup */}
              {isOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/60 z-50">
                  <div className="relative bg-white p-6 rounded-xl max-w-6xl w-full flex items-center justify-center">
                    {/* Close button */}
                    <button
                      className="absolute top-2 right-2 text-white bg-red-500 px-3 py-1 rounded"
                      onClick={() => {
                        setIsOpen(false);
                        setZoom(false);
                        setScale(1); // reset zoom
                      }}
                    >
                      ✕
                    </button>

                    {/* Zoom controls */}
                    <div className="absolute top-4 left-4 flex flex-col gap-2">
                      <button
                        className="bg-blue-500 text-white px-3 py-1 rounded"
                        onClick={() =>
                          setScale((prev) => Math.min(prev + 0.2, 3))
                        }
                      >
                        +
                      </button>
                      <button
                        className="bg-blue-500 text-white px-3 py-1 rounded"
                        onClick={() =>
                          setScale((prev) => Math.max(prev - 0.2, 1))
                        }
                      >
                        -
                      </button>
                    </div>

                    {/* Image container */}
                    <div
                      className="overflow-hidden w-[700px] h-[700px] border relative flex items-center justify-center"
                      onMouseEnter={() => setZoom(true)}
                      onMouseLeave={() => setZoom(false)}
                      onMouseMove={handleMouseMove}
                      onWheel={(e) => {
                        e.preventDefault();
                        if (e.deltaY < 0) {
                          setScale((prev) => Math.min(prev + 0.1, 3)); // zoom in
                        } else {
                          setScale((prev) => Math.max(prev - 0.1, 1)); // zoom out
                        }
                      }}
                    >
                      <img
                        ref={imgRef}
                        src={image}
                        alt="zoomed"
                        className="w-full h-full object-cover transition-transform duration-200"
                        style={{
                          transform: `scale(${
                            zoom ? Math.max(scale, 1.5) : scale
                          })`,
                          transformOrigin: `${position.x}% ${position.y}%`
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Product Info */}
          <div className="flex-1">
            <h1 className="font-medium text-2xl mt-2">{productData.name}</h1>
            <div className="flex items-center gap-1 mt-2">
              {[...Array(5)].map((_, i) => (
                <img
                  key={i}
                  src={assets.star_icon}
                  alt=""
                  className={`w-3.5 ${
                    i < calculateAverageRating() ? "" : "opacity-50"
                  }`}
                />
              ))}
              <p className="pl-2">({reviews?.length || 0})</p>
            </div>
            <div className="mt-5 flex items-center space-x-4">
              <p className="text-3xl font-medium">
                {currency}
                {productData.price}
              </p>
              <p className="text-xl text-gray-500 line-through">
                {currency}
                {productData.originalPrice}
              </p>
            </div>
            <p className="mt-5 text-gray-500 md:w-4/5">
              {productData.description}
            </p>

            {/* Color Selection */}
            <div className="flex flex-col gap-4 my-8">
              {/* Display selected color */}
              <p className="text-gray-600 text-sm">
                Select Color:{" "}
                <span className="font-bold">
                  {colorMapping[color] || color}
                </span>
              </p>
              <div className="flex items-center gap-4">
                {/* Render color radio buttons */}
                <div className="flex gap-2">
                  {productData.colors.map((item, index) => (
                    <label
                      key={index}
                      className="flex items-center gap-2 cursor-pointer"
                    >
                      <input
                        type="radio"
                        name="color"
                        value={item}
                        checked={item === color}
                        onChange={() => setColor(item)}
                        className="hidden" // Hide the default radio button
                      />
                      <span
                        className={`w-6 h-6 rounded-full border-2 flex-shrink-0`}
                        style={{
                          backgroundColor: item,
                          borderColor: item === color ? "#FF4902" : "#d1d5db" // Highlight selected color
                        }}
                      ></span>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            {/* Size Selection */}
            <div className="flex flex-col gap-4 my-8">
              <p>Select Size</p>
              <div className="flex gap-2">
                {productData.sizes.map((item, index) => (
                  <button
                    onClick={() => setSize(item)}
                    className={`border py-2 px-4 bg-gray-100 ${
                      item === size ? "border-[#FF4902]" : ""
                    } ${item === "S" ? "line-clamp-4" : ""}`} // Apply line-through for 'S'
                    key={index}
                  >
                    {item}
                  </button>
                ))}
              </div>

              <div className="flex justify-center sm:justify-start sm:ml-10 md:ml-20 lg:ml-40">
                <SizeChartModal sizeChartImg="https://res.cloudinary.com/dypkxqirq/image/upload/v1755338595/OZ_UX_61___Bone_White_1749115492505_0g7px6ihp2m0l0f_qxkhud.webp" />
              </div>
            </div>
            {/* <button
      onClick={() => {  
        if (!color) {
          alert('Please select a color.');
          return;
        }
        if (!size) {
          alert('Please select a size.');
          return;
        }
        addToCart(productData._id, size, color); // Pass both size and color
      }}
      className='bg-[#FF4902] text-white px-8 py-3 text-sm active:bg-gray-700 rounded-md'
    >
      ADD TO CART
    </button> */}
            <div className="relative">
              {/* Toast Notification */}
              {/* {toast && (
        <div
          className={`fixed bottom-5 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded-md shadow-lg text-white text-sm transition-opacity duration-300 ${
            toast.type === "error" ? "bg-red-500" : "bg-green-500"
          }`}
        >
          {toast.message}
        </div>
      )} */}

              {/* Add to Cart Button */}
              <button
                onClick={handleAddToCart}
                className="bg-[#FF4902] text-white px-8 py-3 text-sm active:bg-gray-700 rounded-md"
              >
                ADD TO CART
              </button>
            </div>
            {/* SKU and Product Details */}
            <div className="mt-5 text-lg text-gray-500">
              <p>
                <strong>SKU:</strong> {productData.SKU}
              </p>
              <p>
                <strong>Category:</strong> {productData.category}
              </p>
              <p>
                <strong>Tags:</strong> designer, t-shirt
              </p>
            </div>

            {/* Share Icons */}

            {/* <div className="mt-5 flex items-center gap-3"> */}
            <div className="mt-5">
  <div className="flex items-center gap-4 text-2xl sm:text-3xl"> {/* <== Added text size here */}
    <p className="text-base sm:text-lg">Share:</p>
    <a
      href={`https://www.facebook.com/messages/t/?text=${encodeURIComponent(productLink)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600"
    >
      <FaFacebook />
    </a>
    <a
      href={`https://www.instagram.com/direct/new/?text=${encodeURIComponent(productLink)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-pink-500"
    >
      <FaInstagram />
    </a>
    <a
      href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(productLink)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-[#1d9bf0]"
    >
      <RiTwitterXLine />
    </a>
    <a
      href={`https://api.whatsapp.com/send?text=${encodeURIComponent(productLink)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-green-500"
    >
      <FaWhatsapp />
    </a>
    <a
      href={`https://t.me/share/url?url=${encodeURIComponent(productLink)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-[#0088cc]"
    >
      <FaTelegramPlane />
    </a>
    <button
      onClick={handleCopyLink}
      className="text-gray-600 hover:text-gray-800"
      title="Copy to clipboard"
    >
      <FaCopy />
    </button>
  </div>

  <div className="mt-3 flex">
    <OurPolicycart className="w-[100px] h-[150px] sm:w-[250px] sm:h-[300px]" />
  </div>
</div>
          </div>
        </div>

        <RecentPurchases />

        {/* Tabs */}
        {/* 
      
      
      <div className='mt-20 justify-centerr'>
        <div className='flex'>
          <button
            className={`px-5 py-3 text-sm ${activeTab === 'description' ? 'border-b-2 border-black' : ''}`}
            onClick={() => setActiveTab('description')}
          >
            Description
          </button>
          <button
            className={`px-5 py-3 text-sm ${activeTab === 'reviews' ? 'border-b-2 border-black' : ''}`}
            onClick={() => setActiveTab('reviews')}
          >
            Reviews ({reviews.length})
          </button>
        </div> */}

        {/* {activeTab === 'description' && (
          <div className='flex flex-col gap-4 border px-6 py-6 text-sm text-gray-500'>
            <p>{productData.description}</p>
          </div>
        )} */}

        {/* Tabs */}
        <div className="mt-20 ">
          <div className="flex space-x-4 justify-center">
            <button
              className={`px-5 py-3 text-sm ${
                activeTab === "description" ? "border-b-2 border-[#FF4902]" : ""
              }`}
              onClick={() => setActiveTab("description")}
            >
              Description
            </button>
            <button
              className={`px-5 py-3 text-sm ${
                activeTab === "reviews" ? "border-b-2 border-[#FF4902]" : ""
              }`}
              onClick={() => setActiveTab("reviews")}
            >
              Reviews ({reviews.length})
            </button>
            <button
              className={`px-5 py-3 text-sm ${
                activeTab === "venderinfo" ? "border-b-2 border-[#FF4902]" : ""
              }`}
              onClick={() => setActiveTab("venderinfo")}
            >
              Vender Info
            </button>
          </div>

          {activeTab === "description" && (
            <div className="flex flex-col gap-10 border px-10 py-10 text-sm text-gray-500 lg:ml-44 mr-10">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="flex flex-col">
                  <h3 className="font-medium text-black mb-7">
                    PRODUCT Specification
                  </h3>
                  <div className="flex items-start">
                    <BsBox className="mr-4 text-6xl" />
                    <p className="text-sm mb-1">
                      This product features unique packaging that <br />
                      includes stickers, accessories, thank you cards, <br />
                      our stock catalog, and more.
                    </p>
                  </div>
                  <p>
                    Our T-shirts are made from high-quality GSM fabric and come{" "}
                    <br /> in a wide range of colors, providing users with
                    plenty of options
                    <br /> to choose from our stock.
                  </p>
                  <p>
                    Our products are finely packed and shipped to verified
                    delivery partners so that there is no chance of damage to
                    the packaging.
                  </p>
                </div>
                <div className="flex flex-col">
                  <h3 className="font-medium text-black mb-7">
                    Material Details
                  </h3>
                  <p>
                    This t-shirt comes with 240 GSM thickness with 100% pure
                    cotton. Fabric weight, measured in GSM, impacts the
                    t-shirt's suitability for different weather conditions and
                    activities. The fit of a t-shirt is influenced by the
                    fabric's stretch, softness, comfort, durability, and
                    sustainability.
                  </p>
                  <ul className="list-disc ml-5">
                    <li>GSM: 240 GSM</li>
                    <li>Colors available: 12+ colors</li>
                    <li>Sizes available: S, M, L, XL, XXL</li>
                    <li>Material: 100% Pure Terry Cotton</li>
                  </ul>
                </div>
                <div className="flex flex-col ">
                  <h3 className="font-medium text-black mb-7">
                    Washing Details
                  </h3>
                  <p>Machine wash is always preferred.</p>
                  <p>Wash inside out to maintain print quality.</p>
                  <p>Do not use iron on print.</p>
                  <h4 className="font-semibold mt-2">Size Chart</h4>
                  <ul className="list-disc ml-5">
                    <li>Nullam id pires: 68.00 cm</li>
                    <li>Etiam non augue: 86.00 cm</li>
                  </ul>
                </div>
              </div>
            </div>
          )}

          {activeTab === "venderinfo" && (
            <div className="flex flex-col gap-5 border px-10 py-10 text-sm text-gray-500 lg:ml-44 mr-10">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div className="flex flex-col">
                  <h3 className="font-medium text-black mb-7">
                    PRODUCT Specification
                  </h3>
                  <div className="flex items-start">
                    <BsBox className="mr-4 text-7xl" />
                    <p className="text-sm  mb-1">
                      Mammoth Streetwears, <br /> OFFICE NO-102,KALPANA TARANG{" "}
                      <br /> APT,OPP,RANKA JEWELLERS,KARVE <br />
                      ROAD,ERANDWANE,PUNE-411004
                    </p>
                  </div>
                  <h3 className="mt-3 text-black">
                    {" "}
                    <strong>Country of Origin :-</strong>
                  </h3>
                  <p>
                    <strong>INDIA</strong> and Proud
                  </p>
                </div>
                <div className="flex flex-col">
                  <h3 className="font-medium text-black mb-7">
                    Material Details
                  </h3>
                  <p>
                    Our products are finely packed and shipped to <br />{" "}
                    verified delivery partners so that there is no <br /> chance
                    of damage to the packaging.
                    <br /> <br />
                    Our T-shirts are made from high-quality GSM <br /> fabric
                    and come in a wide range of colors, <br /> providing users
                    with plenty of options to choose <br /> from our stock.
                  </p>
                </div>
                <div className="flex flex-col ">
                  <h3 className="font-medium text-black mb-7">
                    Material Details
                  </h3>
                  <p font>
                    Our Product comes with 220 to 400 GSM <br /> thickness with
                    100% pure cotton. Fabric weight, <br />
                    measured in GSM, impact of fabric suitability for <br />{" "}
                    different weather conditions and activities. The fit <br />{" "}
                    of fabric is influenced by the fabric's stretch, <br />{" "}
                    softness, comfort, durability, and sustainability. <br />{" "}
                    <br />
                    We have SKU like Oversized T-shirt, Hoodies,
                    <br /> Sweatshirt and Cargo’s and many more coming Soon
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === "reviews" && (
            <div className=" p-6 rounded-lg mt-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Customer Reviews</h2>
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="bg-[#FF4902] text-white px-4 py-2 text-xs rounded-full"
                >
                  Write a Review
                </button>
              </div>
              <div className="flex justify-between w-full sm:w-1/2 mb-6 border p-6 rounded-lg mx-auto">
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between w-full gap-4">
                  {/* Left side: Average Rating */}
                  <div className="flex flex-col items-start w-full md:w-1/3">
                    <h3 className="text-4xl font-semibold">
                      {calculateAverageRating()}{" "}
                      <span className="text-lg">/ 5</span>
                    </h3>
                    <div className="flex items-center gap-1 mt-2">
                      {Array.from({ length: 5 }, (_, i) => (
                        <span
                          key={i}
                          className={`text-3xl ${
                            i < calculateAverageRating()
                              ? "text-yellow-600"
                              : "text-gray-300"
                          }`}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                    <p className="text-sm text-gray-600 mt-1">
                      {reviews.length} Reviews
                    </p>
                  </div>

                  {/* Right side: Rating Progress Bars */}
                  <div className="flex flex-col w-full md:w-2/3">
                    {["5", "4", "3", "2", "1"].map((rating) => {
                      const count = getRatingCounts()[rating];
                      const progressWidth = getProgressBarWidth(
                        count,
                        reviews.length
                      );

                      return (
                        <div
                          key={rating}
                          className="flex items-center justify-between text-sm w-full mb-2"
                        >
                          <span className="w-6 text-center">{rating} ★</span>
                          <div className="flex-1 mx-2 h-2 bg-gray-200 rounded-full overflow-hidden">
                            <div
                              className="h-full bg-yellow-600 transition-all duration-300"
                              style={{ width: `${progressWidth}%` }}
                            />
                          </div>
                          <span className="w-6 text-center">{count}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* Display Reviews */}
              <div className="grid gap-4 overflow-y-auto max-h-[500px] grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
                {reviews.slice(0, displayedReviews).map((review, index) => {
                  const {
                    userName = "Anonymous",
                    rating = 0,
                    comment = "No comment",
                    date = new Date()
                  } = review || {};
                  return (
                    <div
                      key={index}
                      className="p-4 flex items-start gap-4  transition-shadow max-w-full"
                    >
                      {/* Review Content */}
                      <div className="flex-grow max-w-full">
                        {/* Date */}
                        <p className="text-xs text-gray-500 mt-1 font-medium">
                          {new Date(date).toLocaleDateString("en-US", {
                            month: "long",
                            day: "numeric",
                            year: "numeric"
                          })}
                        </p>

                        {/* Stars for Rating */}
                        <div className="flex items-center gap-1 mt-1">
                          {Array.from({ length: 5 }, (_, i) => (
                            <span
                              key={i}
                              className={
                                i < rating ? "text-yellow-600" : "text-gray-300"
                              }
                            >
                              ★
                            </span>
                          ))}
                        </div>

                        {/* Profile Circle and User Name on Same Line */}
                        <div className="flex items-center gap-2 mt-2">
                          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-300 text-blue-700 flex items-center justify-center text-lg font-bold">
                            {userName[0]?.toUpperCase() || "A"}
                          </div>
                          <h3 className="font-semibold text-lg text-gray-800">
                            {userName}
                          </h3>
                        </div>

                        {/* Comment */}
                        <p className="text-gray-800 mt-2 italic border-l-2 border-gray-300 pl-3 max-h-32 overflow-auto">
                          "{comment}"
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* "See More" Button */}
              {reviews.length > displayedReviews && (
                <div className="text-center mt-4">
                  <button
                    onClick={() => setDisplayedReviews(displayedReviews + 5)} // Increment the count
                    className="bg-black text-white px-4 py-2 rounded mt-4"
                  >
                    See More
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        {/* Add Review Button */}

        {/* Add a Review Section */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-8 rounded-lg max-w-md w-full relative justify-cente">
              <h2 className="text-2xl font-medium mb-4 text-center">
                Leave a Review for Mammoth
              </h2>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitReview();
                  setReviewSubmitted(true);
                }}
              >
                <p className="text-center text-sm">
                  How would you rate your Shopping Experience?
                </p>
                {/* Star Rating */}
                <div className="flex  items-center gap-1 mb-2 mt-6">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <div
                      key={star}
                      onClick={() => handleStarClick(star)}
                      className="cursor-pointer"
                    >
                      {review.rating >= star ? (
                        <FaStar className="text-[#FF4902]" size={30} />
                      ) : (
                        <CiStar className="text-[#FF4902]" size={30} />
                      )}
                    </div>
                  ))}
                </div>

                {/* Comment Input */}
                <textarea
                  placeholder="Write a Review..."
                  value={review.comment}
                  onChange={(e) =>
                    setReview({ ...review, comment: e.target.value })
                  }
                  className="block mb-2 w-full h-36 mt-7"
                />

                {/* Name Input */}
                <div className="mb-4">
                  <label
                    htmlFor="userName"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Name
                  </label>
                  <input
                    id="userName"
                    type="text"
                    placeholder="Enter Your Name"
                    value={review.userName}
                    onChange={(e) =>
                      setReview({ ...review, userName: e.target.value })
                    }
                    className="block border p-2 w-full rounded-md"
                    required
                  />
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className={`px-4 py-2 w-full mt-4 rounded-full ${
                    review.rating === 0
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-[#FF4902] text-white"
                  }`}
                  disabled={review.rating === 0}
                >
                  Submit Review
                </button>
                <p className="font-jakarta text-xs mt-3">
                  All reviews on Mammoth Streetwears. Reviews are verified
                  within 48 hours before posting to ensure authenticity and
                  accuracy.
                </p>
              </form>
              {/* Close Button */}
              <button
                onClick={() => setShowConfirmation(true)}
                className="absolute top-2 right-2 text-orange px-3 py-2 rounded-full"
              >
                ×
              </button>

              {/* Confirmation Popup */}
              {showConfirmation && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                  <div className="bg-white p-6 rounded-lg text-center shadow-lg">
                    <p className="text-lg font-semibold mb-4">
                      Do you really want to close the review? Any unsaved
                      changes will be lost.
                    </p>
                    <div className="flex justify-center gap-4">
                      <button
                        onClick={() => {
                          setIsModalOpen(false);
                          setShowConfirmation(false);
                        }}
                        className="bg-[#FF4902] text-white px-4 py-2 rounded-lg"
                      >
                        Yes, Close
                      </button>
                      <button
                        onClick={() => setShowConfirmation(false)}
                        className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {/* Review Submitted Popup */}
              {reviewSubmitted && (
                <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
                  <div className="bg-white p-10 rounded-lg text-center shadow-lg max-w-lg w-full">
                    {/* Icon */}
                    <RiStarSmileFill
                      className="text-[#FF4902] mx-auto"
                      size={100}
                    />
                    {/* Thank You Message */}
                    <h3 className="text-2xl font-semibold mt-4">
                      Thank you for submitting your review!
                    </h3>
                    {/* Additional Info */}
                    <p className="text-sm text-gray-600 mt-2">
                      All reviews on Mammoth Streetwears are verified within 48
                      hours before posting to ensure authenticity and accuracy.
                    </p>
                    {/* Keep Browsing Button */}
                    <button
                      onClick={() => {
                        setReviewSubmitted(false);
                        setIsModalOpen(false);
                      }}
                      className="bg-[#FF4902] text-white px-6 py-2 rounded-lg mt-6"
                    >
                      Keep Browsing
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {toast && (
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => setToast(null)} // Close toast after it appears
          />
        )}

        <RelatedProducts />
      </div>
    </>
  ) : (
    <p>Loading...</p>
  );
};

export default Product;
